import { canPosAction } from './posStaffAccess.js';

/** Valeur persistée localStorage pour la vue multi-postes KDS. */
export const KDS_ALL_STATIONS_ID = '__all__';

/** Vue « Tout » réservée aux profils avec admin restaurant (aligné API kitchen). */
export function canViewAllKdsStations(user) {
  return canPosAction(user, 'caisse:restaurant:admin');
}

/**
 * @param {{ stations: { id: string }[], storageKey: string|null, canViewAll: boolean }} opts
 */
export function resolveInitialKdsStationId({ stations, storageKey, canViewAll }) {
  if (!stations?.length) return '';
  let saved = null;
  try {
    saved = storageKey ? localStorage.getItem(storageKey) : null;
  } catch {
    /* ignore */
  }
  if (saved === KDS_ALL_STATIONS_ID && canViewAll) return KDS_ALL_STATIONS_ID;
  if (saved && stations.some((s) => s.id === saved)) return saved;
  return canViewAll ? KDS_ALL_STATIONS_ID : stations[0].id;
}

/**
 * Regroupe les lignes KDS (file active).
 * @param {object[]} lines
 * @param {{ byCommande?: boolean }} [opts] — en vue « Tout », fusionner les postes d'une même commande.
 */
export function groupKdsQueueLines(lines, { byCommande = false } = {}) {
  const map = new Map();
  for (const line of lines) {
    const commandeId = line.batch?.commandeId;
    const key =
      byCommande && commandeId
        ? `cmd-${commandeId}`
        : line.batchId || commandeId || line.id;
    if (!map.has(key)) {
      map.set(key, {
        key,
        commandeId,
        sentAt: line.sentAt,
        tableLabel: line.liveTableLabel ?? line.tableLabelSnapshot,
        serviceMode: line.serviceModeLabel,
        lines: [],
      });
    }
    const g = map.get(key);
    g.lines.push(line);
    if (line.sentAt && (!g.sentAt || new Date(line.sentAt) < new Date(g.sentAt))) {
      g.sentAt = line.sentAt;
    }
  }
  return [...map.values()].sort(
    (a, b) => new Date(a.sentAt || 0).getTime() - new Date(b.sentAt || 0).getTime()
  );
}

/**
 * Fusionne les files de plusieurs postes (enrichit stationLabel).
 * @param {{ station: { id: string, label: string, code?: string }, lines: object[] }[]} stationQueues
 */
export function mergeKdsStationQueues(stationQueues) {
  const counts = {};
  const merged = [];
  for (const { station, lines } of stationQueues) {
    const batch = lines || [];
    counts[station.id] = batch.length;
    for (const line of batch) {
      merged.push({
        ...line,
        stationLabel: station.label,
        stationCode: station.code,
      });
    }
  }
  return { merged, counts };
}
